<form [formGroup]="patientBudgetForm" class="flex justify-between items-center my-4">
  <div class="flex items-center">
    <div class="mr-2">Site:</div>
    <aux-multi-select-dropdown
      [items]="$any(siteOptions$ | async)"
      [searchable]="true"
      [customOption]="true"
      placeholder="Select"
      formControlName="site_ids"
      class="w-64 mr-3 mt-2"
      bindLabel="textToSearch"
      bindValue="value"
    ></aux-multi-select-dropdown>
  </div>
  <aux-currency-checkboxes
    [selectedCurrencies$]="$any(selectedCurrencies$)"
  ></aux-currency-checkboxes>
</form>
<ag-grid-angular
  domLayout="autoHeight"
  class="ag-theme-aux"
  [gridOptions]="$any(gridOptions$ | async)"
  [rowData]="$any(gridData$ | async)"
  (gridReady)="onGridReady($event)"
  (firstDataRendered)="onDataRendered()"
  (gridSizeChanged)="gridSizeChanged()"
  (viewportChanged)="onWindowScroll()"
>
</ag-grid-angular>
